<template>

	<div class="container-fluid">
		<div class="row">
			<div class="col mb-4">
				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Node Administration</h4>
					</div>
					<div class="card-body">
						<b>Upcoming:</b> This is where all the node administartion features will be, including ecosystem connectivity,
						node details (title, description) and various options regarding the node internal and ecosystem behaviour.
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
export default {
	name: "node-administration",
	props: [ 'nodeId' ]
};
</script>


// WEBPACK FOOTER //
// src/components/NodeAdministration.vue